import { useMutation, useQueryClient } from "@tanstack/react-query";

import { assistantAdminQueryKey } from "@/hooks/queries/useGetAssistantAdmin";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

export function useCancelAssistantSchedule() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ scheduleId }: { scheduleId: string }) => {
      const res = await guacHttpClient.post<
        { ok: true },
        HttpResponse<{ ok: true }>
      >(`assistant/schedules/${scheduleId}/cancel`);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: assistantAdminQueryKey });
    },
  });

  return mutation;
}
